<template>
<v-app id="inspire">
        <v-navigation-drawer v-model="drawer" app fixed color="#fff" style="max-width:250;">
        <v-list-item tow-line color="#000">
            <v-list-item-avatar rounded size="40" color="#fff">
                <v-img src="https://ik.imagekit.io/trainway/avatar.webp?updatedAt=1750180707305"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-subtitle style="color:#000;">
                    <span v-if="name != null">Hello! {{name}}</span>
                    <span v-else>Hello! Welcome</span>
                </v-list-item-subtitle>
                <v-list-item-subtitle style="color:#000;">
                    <span v-if="email != null">{{email}}</span>
                    <span v-else>Guest</span>
                </v-list-item-subtitle>
            </v-list-item-content>

        </v-list-item>

        <v-divider></v-divider>
        <v-list nav dense>
            <v-subheader>
                Users & Company Profile
            </v-subheader>

            <v-list-item to="/myaccount">
                <v-list-item-icon>
                    <v-icon color="#000">mdi-contacts-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>My Account</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/more">
                <v-list-item-icon>
                    <v-icon color="#000">mdi-home-import-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>More</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-icon>
            </v-list-item>
           <v-subheader>
                Other Service
            </v-subheader>
            <v-list-item to="/group-order">
                <v-list-item-icon>
                    <v-icon color="#000">mdi-account-multiple</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Group Order</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-icon>
            </v-list-item>

         <v-list-item to="/restaurant-signup">
                <v-list-item-icon>
                    <v-icon color="#000">mdi-card-account-details</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Vendor Registration</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/track-order">
                <v-list-item-icon>
                    <v-icon color="#000">mdi-shopping-search</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Track Order</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-icon>
            </v-list-item>

            <v-subheader>Contact Info </v-subheader>

            <v-list-item class="contactinfo">
                <v-list-item-content>
                    <v-list-item-title tag="a" href="tel:+91 88099-52644">
                        <v-icon>mdi-phone-classic</v-icon> +91 88099-52644
                    </v-list-item-title>
                    <v-list-item-title tag="a" href="https://api.whatsapp.com/send?phone=918809952644" target="_blank">
                        <v-icon>mdi-whatsapp</v-icon> +91 88099-52644
                    </v-list-item-title>
                    <!-- <v-list-item-title tag="a" href="mailto:support@trainway.co.in" target="_blank">
                        <v-icon>mdi-email-outline</v-icon> support@trainway.co.in
                    </v-list-item-title>
                    <v-list-item-title tag="a" href="https://www.facebook.com/profile.php?id=61550849225493/" target="_blank">
                        <v-icon>mdi-facebook</v-icon> Follow us on Facebook
                    </v-list-item-title>
                    <v-list-item-title tag="a" href="https://in.pinterest.com/trainway/" target="_blank">
                        <v-icon>mdi-pinterest</v-icon> Follow us on Twitter
                    </v-list-item-title>
                    <v-list-item-title tag="a" href="https://www.instagram.com/trainwaay/" target="_blank">
                        <v-icon>mdi-instagram</v-icon> Follow us on Instagram
                    </v-list-item-title>
                    <v-list-item-title tag="a" href="https://www.youtube.com/@trainwaay/
" target="_blank">
                        <v-icon>mdi-youtube</v-icon> Follow us on YouTube
                    </v-list-item-title> -->

                </v-list-item-content>
            </v-list-item>

            <!-- <v-subheader>
             Download the App
            </v-subheader>

            <v-list-item>
                <v-list-item-content class="contactinfo">
                    <v-list-item-title tag="a" href="mailto:support@trainway.co.in" target="_blank">
                    <v-img src="/images/gplay.webp"></v-img>
                    </v-list-item-title>
                    <v-list-item-title tag="a" href="mailto:support@trainway.co.in" target="_blank">
                     <v-img src="/images/appstore.webp"></v-img>
                    </v-list-item-title>
            </v-list-item-content>
            </v-list-item> -->

        </v-list>
    </v-navigation-drawer>

     <v-app-bar app elevation="0" color="#05445E" dark fixed top>

            <v-container class="fill-height d-flex d-sm-none align-center py-0 px-0">
                <v-app-bar-nav-icon @click="drawersidebar" style="color: #ffffff; margin-left: -19px;"
                    class="d-block d-sm-none"></v-app-bar-nav-icon>
                    <v-img src="https://ik.imagekit.io/trainway/trainway.webp?updatedAt=1750180725826" max-width="130"></v-img>
                <v-spacer></v-spacer>
                <v-btn href="tel:+9188099-52644" elevation="0" color="#ffffff" text class="px-1" style="min-width: 40px">
                   <v-icon>mdi-cellphone-basic</v-icon>
               </v-btn>
               <v-btn href="whatsapp://send?text=trainway=+9188099-52644" elevation="0" color="#ffffff" text class="px-1" style="min-width: 40px">
               <v-icon>mdi-whatsapp</v-icon>
             </v-btn>
            </v-container>

            <v-container class="fill-height d-none d-sm-flex align-center">
                <router-link to="/"> <v-img src="https://ik.imagekit.io/trainway/trainway.webp?updatedAt=1750180725826" max-width="130"></v-img>  </router-link>
                <v-spacer></v-spacer>
                <v-btn to="/" elevation="0" color="#ffffff" text>HOME</v-btn>
                <v-btn to="/check-pnr-status" elevation="0" color="#ffffff" text>PNR STATUS</v-btn>
                <v-btn to="/train-running-status" elevation="0" color="#ffffff" text>RUNNING STATUS</v-btn>
                <v-btn to="/seat-availability" elevation="0" color="#ffffff" text>SEAT AVAILABILITY</v-btn>
                <v-btn to="/train-between-stations" elevation="0" color="#ffffff" text>TRAIN BETWEEN STATION</v-btn>
                <v-btn to="/login" elevation="0" color="#ffffff" text>TRACK ORDER</v-btn>
                <v-btn href="tel:+9188099-52644" elevation="0" color="#ffffff" text class="px-1" style="min-width: 30px">
        <v-icon>mdi-cellphone-basic</v-icon>  </v-btn>
        <v-btn href="whatsapp://send?text=trainway=+9188099-52644" elevation="0" color="#ffffff" text class="px-1" style="min-width: 30px">
        <v-icon>mdi-whatsapp</v-icon> </v-btn>
        </v-container>
    </v-app-bar>

    <v-main>
        <v-container>
            <v-row>
                <v-col cols="12">
                    <div v-for="(page, index) in pages" :key="index">
                        <v-list-item  class="px-0" :to="page.url">
                            <v-list-item-icon >
                                <v-icon color="#000" v-text="page.icon"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title v-text="page.title"></v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-icon>mdi-chevron-right</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </div>
                </v-col>
            </v-row>

        </v-container>
    </v-main>
</v-app>
</template>

<script>
export default {
    data: () => ({
        pages: [
            {
                title: 'About Us',
                url: '/about-us',
                icon: 'mdi-format-line-height',
            },
            {
                icon: 'mdi-shopping-search',
                title: 'How To Order',
                url: '/how-to-order'
            },
            {
                icon: 'mdi-comment-text-multiple',
                title: 'Contact Us',
                url: '/contact-us'
            },
            {
                icon: 'mdi-content-paste',
                title: 'Terms & Conditions',
                url: '/terms-and-condition'
            },
            {
                icon: 'mdi-clipboard-multiple-outline',
                title: 'Privacy policy',
                url: '/privacy-policy'
            },
            {
                icon: 'mdi-clipboard-file-outline',
                title: 'Disclaimer',
                url: '/disclaimer'
            },
            {
                icon: 'mdi-clipboard-file-outline',
                title: 'FAQs',
                url: '/faqs'
            },
            {
                icon: 'mdi-sack',
                title: 'Cancellation Policy',
                url: '/cancellation-policy'
            },
            {
                icon: 'mdi-ab-testing',
                title: 'Quality Assurance',
                url: '/quality-assurance'
            },
            // {
            //     icon: 'mdi-ab-testing',
            //     title: 'FAQs',
            //     url: '/FAQs'
            // },
            // {
            //     icon: 'mdi-ab-testing',
            //     title: 'sitemap'
            //     url: '/sitemap'
            // },
      ],
    }),
}
</script>
